/** What to keep from a given day when culling */
export var FeedKeepFromDay;
(function (FeedKeepFromDay) {
    /** Keep photos from specified time slots */
    FeedKeepFromDay[FeedKeepFromDay["TimeSlots"] = 0] = "TimeSlots";
    /** Keep the first photo from the day */
    FeedKeepFromDay[FeedKeepFromDay["First"] = 1] = "First";
    /** Keep whichever photo is near the middle of the list of them from the day */
    FeedKeepFromDay[FeedKeepFromDay["Middle"] = 2] = "Middle";
    /** Keep the last photo from the day */
    FeedKeepFromDay[FeedKeepFromDay["Last"] = 3] = "Last";
    /** Delete all photos that reach this age */
    FeedKeepFromDay[FeedKeepFromDay["None"] = 4] = "None";
})(FeedKeepFromDay || (FeedKeepFromDay = {}));
